// Packages
import { animateScroll as scroll } from 'react-scroll'

// Components
import { Box, Flex, Text, Button } from 'yard-utilities/components'
import SvgBox from '@components/helpers/SvgBox'
import ListItem from '@components/v21/common/list-item/ListItem'
import Tag from '@components/v25/common/tag/Tag'
import CreateAccount from './create-account/CreateAccount'
import Separation from '@components/v25/common/separation/Separation'

// Icons
import { CheckmarkCircle } from 'icons/v21/Icons'

// Styles
import styles from './MembershipCard.module.sass'

const features = [
  'Instant access to RatePunk system',
  'Flight deals up to 90% off',
  'Unlimited flight deal alerts',
  'Deals in over 100+ destinations',
  'Flights from your home airport',
  'Peak season & holiday flights',
  'Daily support and guidance',
  '30-day Money Back Guarantee',
  'Cancel anytime'
]

interface MembershipWrapperProps {
  redirectURL?: string
}

const MembershipWrapper = ({ redirectURL }: MembershipWrapperProps) => {
  return (
    <Box
      backgroundColor="yellow-10"
      borderRadius={{ sm: [16] }}
      shadow="shadowDefault"
      className={styles.section}
    >
      <Flex flexDirection="column" rowGap={{ sm: 24 }}>
        <Box
          className={styles.container}
          overflow="hidden"
          padding={{ sm: [32, 24, 24] }}
          borderRadius={{ sm: [16, 16, 0, 0] }}
        >
          <div className={styles.content}>
            <Text
              tagName="h3"
              variant="title-2"
              spacing={{ sm: 4 }}
              align="center"
              transform="uppercase"
            >
              1 year membership
            </Text>
            <Text
              tagName="p"
              variant="body-6"
              spacing={{ sm: 24 }}
              align="center"
              textColor="red-10"
            >
              Now with limited time discount!
            </Text>

            <Flex flexDirection="column" alignItems="center" rowGap={{ sm: 4 }}>
              <Box spacing={{ sm: 4 }}>
                <Tag backgroundColor="red" variant="type-6" textSize="body-3">
                  Save 77%
                </Tag>
              </Box>

              <Flex columnGap={{ sm: 8 }} alignItems="center">
                <Text
                  tagName="p"
                  variant="body-4"
                  textColor="grey-2"
                  decoration="lineThrough"
                >
                  $2
                </Text>
                <Text tagName="p" variant="title-6">
                  $0.46
                </Text>
                <Text tagName="p" variant="title-3">
                  /week
                </Text>
              </Flex>

              <Text tagName="p" variant="body-6" textColor="grey-2">
                Billed annually
              </Text>
            </Flex>
          </div>
        </Box>

        <Box padding={{ sm: [0, 24, 32] }}>
          <Features />

          {redirectURL ? (
            <CreateAccount redirectURL={redirectURL} />
          ) : (
            <Button
              variant="yellow"
              transform="uppercase"
              onClick={() => scroll.scrollToTop({ duration: 0 })}
              style={{ marginTop: '-1.6rem' }}
            >
              start now
            </Button>
          )}
        </Box>
      </Flex>
    </Box>
  )
}

const Features = () => {
  return (
    <>
      <FeaturesTitle>what you get</FeaturesTitle>

      <Flex flexDirection="column" rowGap={{ sm: 16 }} spacing={{ sm: 48 }}>
        {features.map((item, i) => (
          <ListItem
            key={i}
            icon={
              <SvgBox offset={3}>
                <CheckmarkCircle color="#00B67A" />
              </SvgBox>
            }
            textSize="body-1"
            fontWeight={400}
            gap={[8]}
            position="flex-start"
          >
            {item}
          </ListItem>
        ))}
      </Flex>
    </>
  )
}

const FeaturesTitle = ({ children }: { children: string }) => {
  return (
    <Flex alignItems="center" columnGap={{ sm: 16 }} spacing={{ sm: 32 }}>
      <Separation hexColor="#CCC" />
      <Text
        tagName="h4"
        variant="title-3"
        align="center"
        transform="capitalize"
      >
        {children}
      </Text>
      <Separation hexColor="#CCC" />
    </Flex>
  )
}

export default MembershipWrapper
